import IpcRouter from '@shared/ipc/IpcRouter'
import type { ChatTurnTelemetryEvent } from '@shared/chat-telemetry/turn-events'

export interface ChatTelemetryIpcRouterType {
  /**
   * Record one chat turn lifecycle event on main's OpenTelemetry tracer.
   * Fire-and-forget from the renderer's point of view; a lost event costs a
   * span event, never the turn.
   */
  record(event: ChatTurnTelemetryEvent): Promise<void>
}

class ChatTelemetryIpcRouter extends IpcRouter<ChatTelemetryIpcRouterType> {
  constructor() {
    super('chat-telemetry', {
      record: true,
    })
  }
}

export default ChatTelemetryIpcRouter
